import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../../Shared/AdminNavbar/Navbar";
import baseURL from "../../../Apiurs/Apiurls";
import "./Company.css";

const Company = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});

  // Input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Enable edit mode
  const handleEditClick = () => {
    setFormData(company || {});
    setEditMode(true);
  };

const handleSave = async () => {
  try {
    if (!company?.id) return alert("Company ID missing ❌");

    // 1️⃣ Send update to backend
    await axios.put(`${baseURL}/api/company/${company.id}`, formData);
    
    alert("Company updated successfully ✅");

    // 2️⃣ Refetch the latest company from backend
    const response = await axios.get(`${baseURL}/api/company/${company.id}`);
    setCompany(response.data); // ✅ Now company state matches backend
    setEditMode(false);
  } catch (err) {
    console.error("Update error:", err);
    alert("Failed to update company ❌");
  }
};

  // Fetch the single company row
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/company/1`);
        setCompany(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Company data not found");
        setLoading(false);
      }
    };
    fetchCompany();
  }, []);

  if (loading)
    return (
      <div className="CollapseContainer">
        <Navbar onToggleSidebar={setCollapsed} />
        <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
          <div className="container mt-4 text-center">Loading...</div>
        </div>
      </div>
    );

  if (error || !company)
    return (
      <div className="CollapseContainer">
        <Navbar onToggleSidebar={setCollapsed} />
        <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
          <div className="container mt-4">
            <div className="alert alert-danger mt-5 text-center">{error}</div>
          </div>
        </div>
      </div>
    );

  // Fields to display (removed bank details as per your previous request)
  const fields = [
    { label: "Company Name", key: "legalName" },
    { label: "Bank Name", key: "bankName" },
    { label: " Account No", key: "accountNo" },
    { label: " IFSC Code", key: "ifscCode" },
    { label: "Branch ", key: "branch" },
    { label: "GSTIN No", key: "gstin" },
    { label: "PAN No", key: "pan" },
   { label: "Importer Exporter Code ", key: "iec" },
  { label: "ISO Certification ", key: "isoCer" }
  ];

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="employee-view-container">
          <div className="employee-view-card">
            <div className="employee-view-header">
              <h3 className="employee-view-title">Company Details</h3>
              {!editMode ? (
                <button onClick={handleEditClick} className="edit-btn">
                  Edit
                </button>
              ) : (
                <button onClick={handleSave} className="save-btn">
                  Save
                </button>
              )}
            </div>

            <div className="employee-section">
              <h6>Company Information</h6>
              <div className="employee-info">
                {fields.map(({ label, key }) => (
                  <div key={key} className="employee-info-row">
                    <strong>{label}:</strong>
                    {editMode ? (
                      <input
                        type="text"
                        name={key}
                        value={formData[key] || ""}
                        onChange={handleChange}
                        className="edit-input"
                      />
                    ) : (
                      <span>{company[key] || "N/A"}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
